import React from 'react'
import Scholarship from './Scholarship'
import QualityPlaceToLearn from './QualityPlaceToLearn'
// import OurPotentialBootcamps from '../OurPotentialBootcamps'
// import DayOfCodeDemo from '../DayOfCodeDemo'
import ThirtyDaysOfCode from './ThirtyDaysOfCode'
import Benifits from './Benifits'

function ThirtyDaysLanding() {
  return (
    <>
      {/* <DayOfCodeDemo /> */}
      <ThirtyDaysOfCode />
      <Scholarship />
      <QualityPlaceToLearn />
      {/* <OurPotentialBootcamps /> */}
      <Benifits />
    </>
  )
}

export default ThirtyDaysLanding

